// // import { useState, useEffect, useCallback } from "react";
// // import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
// // import { db } from "../../firebase";

// // export const useCartCalculations = ({
// //   cartProducts,
// //   discountInHok,
// //   currentUser,
// // }) => {
// //   const [totalPrice, setTotalPrice] = useState(0);
// //   const [newFinValue, setNewFinValue] = useState(0);
// //   const [visibleDiscount, setVisibleDiscount] = useState(0);
// //   const [promoCode, setPromoCode] = useState("");

// //   // ефективна (базова для підсумків) ціна одиниці товару
// //   const effectiveItemPrice = (item) => {
// //     const hasPriceSale =
// //       item.priceSale !== undefined &&
// //       item.priceSale !== null &&
// //       item.priceSale !== "";
// //     const isSale = !!item.saleDiscountPercent;
// //     const isAction = !!item.actionDiscountPercent;

// //     if (hasPriceSale) return Number(item.priceSale);
// //     if (isSale)
// //       return Math.round(
// //         item.price - (item.price * Number(item.saleDiscountPercent)) / 100
// //       );
// //     if (isAction)
// //       return Math.round(
// //         item.price - (item.price * Number(item.actionDiscountPercent)) / 100
// //       );
// //     return Number(item.price);
// //   };

// //   useEffect(() => {
// //     if (!cartProducts) return;

// //     const calculate = async () => {
// //       let total = 0;
// //       let nonDiscountedPart = 0; // частина, на яку можна накладати профільну/cartdiscount

// //       cartProducts.forEach((item) => {
// //         const isSale = !!item.saleDiscountPercent; // ⬅️ розпродаж
// //         const isAction = !!item.actionDiscountPercent;

// //         const basePrice = effectiveItemPrice(item);
// //         total += basePrice * item.quantity;

// //         // ❗️Промо/профільна/cartdiscount НЕ застосовуються до розпродажу і акцій
// //         if (!isSale && !isAction) {
// //           nonDiscountedPart += basePrice * item.quantity;
// //         }
// //       });

// //       setTotalPrice(Math.round(total));

// //       let finalValue = total;

// //       // профільна знижка (лише до nonDiscountedPart)
// //       if (discountInHok > 0 && nonDiscountedPart > 0) {
// //         const profileDiscount = (nonDiscountedPart * discountInHok) / 100;
// //         finalValue -= profileDiscount;
// //       }

// //       // cartdiscount (також лише до nonDiscountedPart)
// //       const snapshot = await getDocs(collection(db, "cartdiscount"));
// //       const now = new Date();
// //       const discounts = snapshot.docs
// //         .map((doc) => ({ id: doc.id, ...doc.data() }))
// //         .filter((d) => {
// //           const start = d.startDate ? new Date(d.startDate) : null;
// //           const end = d.endDate ? new Date(d.endDate) : null;
// //           return (
// //             (!start || now >= start) &&
// //             (!end || now <= end) &&
// //             nonDiscountedPart >= d.amount
// //           );
// //         })
// //         .sort((a, b) => b.amount - a.amount);

// //       let cartDiscountPercent = 0;
// //       if (discounts.length) {
// //         cartDiscountPercent = discounts[0].percent;
// //       }

// //       if (cartDiscountPercent > 0 && nonDiscountedPart > 0) {
// //         const cartDiscValue = (nonDiscountedPart * cartDiscountPercent) / 100;
// //         finalValue -= cartDiscValue;
// //       }

// //       setNewFinValue(Math.round(finalValue));
// //       setVisibleDiscount(cartDiscountPercent);
// //     };

// //     calculate();
// //   }, [cartProducts, discountInHok]);

// //   const applyPromoCode = useCallback(
// //     async (promoData, currentCart) => {
// //       if (!promoData || promoData.code !== promoCode) return false;
// //       if (!currentCart || currentCart.length === 0) return false;

// //       const appliesTo = promoData.appliesTo || {};
// //       const appliesToProducts = appliesTo.products || [];
// //       const appliesToAuthors = appliesTo.authors || [];
// //       const appliesToSeries = appliesTo.series || [];

// //       const isUniversal =
// //         appliesToProducts.length === 0 &&
// //         appliesToAuthors.length === 0 &&
// //         appliesToSeries.length === 0;

// //       let nonDiscountedPart = 0;

// //       currentCart.forEach((item) => {
// //         const isSale = !!item.saleDiscountPercent; // ❗️не беремо у промо
// //         const isAction = !!item.actionDiscountPercent; // як і раніше — теж ні
// //         if (isSale || isAction) return;

// //         // чи підпадає за таргетом промо
// //         let match = false;

// //         if (isUniversal) {
// //           match = true;
// //         } else {
// //           const matchProduct = appliesToProducts.includes(item.id);

// //           const itemAuthors = Array.isArray(item.textAutor)
// //             ? item.textAutor.map((a) => a.split(" ")[0].toLowerCase())
// //             : typeof item.textAutor === "string"
// //             ? [item.textAutor.split(" ")[0].toLowerCase()]
// //             : [];

// //           const matchAuthor = itemAuthors.some((a) =>
// //             appliesToAuthors
// //               .map((x) => x.split(" ")[0].toLowerCase())
// //               .includes(a)
// //           );

// //           const itemSeries = Array.isArray(item.seria)
// //             ? item.seria
// //             : typeof item.seria === "string"
// //             ? [item.seria]
// //             : [];

// //           const matchSeries = itemSeries.some((s) =>
// //             appliesToSeries.includes(s)
// //           );

// //           match = matchProduct || matchAuthor || matchSeries;
// //         }

// //         if (match) {
// //           const eff = effectiveItemPrice(item); // консистентно з total
// //           nonDiscountedPart += eff * item.quantity;
// //         }
// //       });

// //       if (nonDiscountedPart <= 0) return false;

// //       const promoDiscount = (nonDiscountedPart * promoData.discount) / 100;

// //       // нова сума: (все інше) + (eligible частина з промо-знижкою)
// //       const nonPromoPart = totalPrice - nonDiscountedPart;
// //       const newFinal = nonPromoPart + (nonDiscountedPart - promoDiscount);

// //       setNewFinValue(Math.round(newFinal));

// //       if (promoData.isSingleUse) {
// //         await deleteDoc(doc(db, "promo", promoData.id));
// //       }

// //       return true;
// //     },
// //     [promoCode, totalPrice]
// //   );

// //   const applyElefant = async (updateUserElefant) => {
// //     if (!currentUser || parseInt(currentUser.elefant) === 0) return false;
// //     const elephants = parseInt(currentUser.elefant);
// //     const updatedValue = Math.max(newFinValue - elephants, 0);
// //     setNewFinValue(Math.round(updatedValue));
// //     await updateUserElefant(currentUser.uid);
// //     return elephants;
// //   };

// //   return {
// //     totalPrice,
// //     newFinValue,
// //     visibleDiscount,
// //     promoCode,
// //     setPromoCode,
// //     applyPromoCode,
// //     applyElefant,
// //   };
// // };
// import { useState, useEffect, useCallback, useMemo } from "react";
// import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
// import { db } from "../../firebase";
// const ROLES = {
//   CLUB: 'Член "Клубу Майстрів"',
//   LIBRARIAN: "Бібліотекар",
//   BUSINESS: "Бізнес-партнер",
//   MASTER: "Майстер",
// };
// const MAX_AUTO_DISCOUNT = 40;
// const DEBUG_DISCOUNTS = true;
// const log = (...args) => {
//   if (DEBUG_DISCOUNTS) console.log(...args);
// };
// const warn = (...args) => {
//   if (DEBUG_DISCOUNTS) console.warn(...args);
// };
// const errorLog = (...args) => {
//   if (DEBUG_DISCOUNTS) console.error(...args);
// };
// const group = (title, callback) => {
//   if (!DEBUG_DISCOUNTS) {
//     callback();
//     return;
//   }
//   if (console.groupCollapsed) {
//     console.groupCollapsed(title);
//     try {
//       callback();
//     } finally {
//       console.groupEnd();
//     }
//   } else {
//     callback();
//   }
// };
// const hasValue = (value) =>
//   value !== undefined && value !== null && String(value).trim() !== "";
// const toNumber = (value) => Number(value) || 0;
// const round = (value) => Math.round(Number(value) || 0);
// const clampPercent = (value, max = 100) =>
//   Math.max(0, Math.min(toNumber(value), max));
// const normalizeText = (value) =>
//   String(value || "")
//     .trim()
//     .replace(/\s+/g, " ")
//     .toLowerCase();
// const resolveRole = (user) => {
//   const rawRole =
//     user?.category ??
//     user?.role ??
//     user?.userRole ??
//     user?.roleName ??
//     user?.accountType ??
//     user?.customerType ??
//     "";
//   const normalizedRole = normalizeText(rawRole);
//   let resolvedRole = user?.uid ? "user" : "guest";
//   if (normalizedRole === normalizeText(ROLES.BUSINESS)) {
//     resolvedRole = "business_partner";
//   } else if (normalizedRole === normalizeText(ROLES.LIBRARIAN)) {
//     resolvedRole = "librarian";
//   } else if (normalizedRole === normalizeText(ROLES.CLUB)) {
//     resolvedRole = "club_member";
//   } else if (normalizedRole === normalizeText(ROLES.MASTER)) {
//     resolvedRole = "master";
//   }
//   group("🧩 resolveRole()", () => {
//     log("rawRole:", rawRole);
//     log("normalizedRole:", normalizedRole);
//     log("resolvedRole:", resolvedRole);
//     log("user?.category:", user?.category);
//     log("user?.role:", user?.role);
//     log("user?.userRole:", user?.userRole);
//     log("user?.accountType:", user?.accountType);
//     log("user?.customerType:", user?.customerType);
//   });
//   return resolvedRole;
// };
// const isPrivilegedRole = (role) =>
//   role === "business_partner" || role === "librarian";
// const isTelegramSigned = (user) => {
//   const raw =
//     user?.signed ??
//     user?.telegramSubscribed ??
//     user?.isTelegramSubscribed ??
//     false;
//   const result = raw === true || raw === "true" || raw === 1 || raw === "1";
//   group("📨 isTelegramSigned()", () => {
//     log("raw:", raw);
//     log("result:", result);
//   });
//   return result;
// };
// const isPreorder = (item) =>
//   Boolean(
//     item?.isPreorder ||
//     item?.preorder ||
//     item?.categorySlug === "predprodazh" ||
//     item?.section === "predprodazh" ||
//     item?.group === "predprodazh",
//   );
// const hasAction = (item) => clampPercent(item?.actionDiscountPercent) > 0;
// const hasSale = (item) =>
//   (hasValue(item?.priceSale) && !isPreorder(item)) ||
//   clampPercent(item?.saleDiscountPercent) > 0;
// const getListPrice = (item) => round(item?.price);
// const getActionPrice = (item) => {
//   const price = getListPrice(item);
//   const percent = clampPercent(item?.actionDiscountPercent);
//   const result = !percent ? price : round(price - (price * percent) / 100);
//   group(
//     `🏷️ getActionPrice: ${item?.bookName || item?.title || item?.id || "item"}`,
//     () => {
//       log("price:", price);
//       log("actionDiscountPercent raw:", item?.actionDiscountPercent);
//       log("actionDiscountPercent normalized:", percent);
//       log("result:", result);
//     },
//   );
//   return result;
// };
// const getSalePrice = (item) => {
//   let result = getListPrice(item);
//   if (hasValue(item?.priceSale) && !isPreorder(item)) {
//     result = round(item.priceSale);
//   } else {
//     const price = getListPrice(item);
//     const percent = clampPercent(item?.saleDiscountPercent);
//     if (percent > 0) {
//       result = round(price - (price * percent) / 100);
//     }
//   }
//   group(
//     `💸 getSalePrice: ${item?.bookName || item?.title || item?.id || "item"}`,
//     () => {
//       log("price:", getListPrice(item));
//       log("priceSale raw:", item?.priceSale);
//       log("saleDiscountPercent raw:", item?.saleDiscountPercent);
//       log("result:", result);
//     },
//   );
//   return result;
// };
// const getPreorderPrice = (item) => {
//   let result = getListPrice(item);
//   if (hasValue(item?.preorderPrice)) {
//     result = round(item.preorderPrice);
//   } else if (hasValue(item?.priceSale)) {
//     result = round(item.priceSale);
//   }
//   group(
//     `📦 getPreorderPrice: ${item?.bookName || item?.title || item?.id || "item"}`,
//     () => {
//       log("preorderPrice raw:", item?.preorderPrice);
//       log("priceSale raw:", item?.priceSale);
//       log("result:", result);
//     },
//   );
//   return result;
// };
// const isRuleActiveNow = (rule) => {
//   if (rule?.active === false) {
//     warn("rule inactive because active=false", rule);
//     return false;
//   }
//   const now = new Date();
//   const start = hasValue(rule?.startDate) ? new Date(rule.startDate) : null;
//   const end = hasValue(rule?.endDate) ? new Date(rule.endDate) : null;
//   if (start && Number.isNaN(start.getTime())) {
//     warn("invalid startDate in rule", rule);
//     return false;
//   }
//   if (end && Number.isNaN(end.getTime())) {
//     warn("invalid endDate in rule", rule);
//     return false;
//   }
//   if (start && now < start) return false;
//   if (end && now > end) return false;
//   return true;
// };
// const getTierPercent = (rules, priceListSubtotal) => {
//   group("📚 getTierPercent()", () => {
//     log("priceListSubtotal:", priceListSubtotal);
//     log("rules:", rules);
//   });
//   const matched = [...rules]
//     .filter((rule) => {
//       const amount = toNumber(rule?.amount || 0);
//       const active = isRuleActiveNow(rule);
//       const subtotalOk = priceListSubtotal >= amount;
//       log("rule check:", {
//         id: rule?.id,
//         amountRaw: rule?.amount,
//         amount,
//         percent: rule?.percent,
//         active,
//         subtotalOk,
//         priceListSubtotal,
//       });
//       return active && subtotalOk;
//     })
//     .sort((a, b) => toNumber(b?.amount || 0) - toNumber(a?.amount || 0));
//   const result = matched.length
//     ? clampPercent(matched[0]?.percent, MAX_AUTO_DISCOUNT)
//     : 0;
//   group("📚 getTierPercent result", () => {
//     log("matched:", matched);
//     log("result:", result);
//   });
//   return result;
// };
// const normalizeAuthorKey = (value) =>
//   String(value || "")
//     .trim()
//     .split(" ")[0]
//     .toLowerCase();
// export const useCartCalculations = ({
//   cartProducts = [],
//   discountInHok = 0,
//   currentUser,
// }) => {
//   const [discountRules, setDiscountRules] = useState([]);
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [priceListSubtotal, setPriceListSubtotal] = useState(0);
//   const [baseFinalValue, setBaseFinalValue] = useState(0);
//   const [promoDiscountValue, setPromoDiscountValue] = useState(0);
//   const [elefantApplied, setElefantApplied] = useState(0);
//   const [visibleDiscount, setVisibleDiscount] = useState(0);
//   const [appliedDiscountType, setAppliedDiscountType] = useState("none");
//   const [pricingLines, setPricingLines] = useState([]);
//   const [promoCode, setPromoCode] = useState("");
//   const role = resolveRole(currentUser);
//   const personalDiscountRaw =
//     currentUser?.discount ??
//     currentUser?.personalDiscount ??
//     currentUser?.userDiscount ??
//     discountInHok ??
//     0;
//   const personalDiscount = clampPercent(personalDiscountRaw, MAX_AUTO_DISCOUNT);
//   const clubExtraDiscount = isTelegramSigned(currentUser) ? 5 : 0;
//   useEffect(() => {
//     const loadRules = async () => {
//       try {
//         const snap = await getDocs(collection(db, "cartdiscount"));
//         const rules = snap.docs.map((item) => ({
//           id: item.id,
//           ...item.data(),
//         }));
//         group("🗂️ cartdiscount rules loaded", () => {
//           log("rules:", rules);
//         });
//         setDiscountRules(rules);
//       } catch (err) {
//         errorLog("❌ error loading cartdiscount", err);
//       }
//     };
//     loadRules();
//   }, []);
//   useEffect(() => {
//     group("🚀 useCartCalculations INIT", () => {
//       log("currentUser:", currentUser);
//       log("currentUser keys:", Object.keys(currentUser || {}));
//       log("currentUser.category:", currentUser?.category);
//       log("resolved role:", role);
//       log("currentUser.discount:", currentUser?.discount);
//       log("discountInHok prop:", discountInHok);
//       log("personalDiscountRaw:", personalDiscountRaw);
//       log("personalDiscount clamped:", personalDiscount);
//       log("currentUser.signed:", currentUser?.signed);
//       log("clubExtraDiscount:", clubExtraDiscount);
//       log("currentUser.elefant:", currentUser?.elefant);
//     });
//   }, [
//     currentUser,
//     role,
//     discountInHok,
//     personalDiscountRaw,
//     personalDiscount,
//     clubExtraDiscount,
//   ]);
//   useEffect(() => {
//     group("🧮 MAIN CALCULATION START", () => {
//       log("role:", role);
//       log("personalDiscount:", personalDiscount);
//       log("discountRules:", discountRules);
//       log("cartProducts:", cartProducts);
//     });
//     const subtotalByPriceList = (cartProducts || []).reduce((acc, item) => {
//       const listPrice = getListPrice(item);
//       const qty = toNumber(item.quantity || 1);
//       const line = listPrice * qty;
//       log("subtotal item:", {
//         id: item?.id,
//         title: item?.bookName || item?.title,
//         listPrice,
//         qty,
//         line,
//       });
//       return acc + line;
//     }, 0);
//     const autoTierPercent = currentUser?.uid
//       ? getTierPercent(discountRules, subtotalByPriceList)
//       : 0;
//     group("📊 subtotal + tier", () => {
//       log("subtotalByPriceList:", subtotalByPriceList);
//       log("currentUser.uid:", currentUser?.uid);
//       log("autoTierPercent:", autoTierPercent);
//       log("personalDiscount:", personalDiscount);
//       log("isPrivilegedRole(role):", isPrivilegedRole(role));
//     });
//     let displaySubtotal = 0;
//     let calculatedFinal = 0;
//     const nextLines = [];
//     (cartProducts || []).forEach((item, index) => {
//       const qty = toNumber(item.quantity || 1);
//       const listPrice = getListPrice(item);
//       let displayUnitPrice = listPrice;
//       let finalUnitPrice = listPrice;
//       let lineDiscountType = "none";
//       let lineDiscountPercent = 0;
//       let promoEligible = true;
//       let branchUsed = "none";
//       group(
//         `📘 ITEM #${index + 1}: ${item?.bookName || item?.title || item?.id || "item"}`,
//         () => {
//           log("raw item:", item);
//           log("qty:", qty);
//           log("listPrice:", listPrice);
//           log("isPreorder:", isPreorder(item));
//           log("hasSale:", hasSale(item));
//           log("hasAction:", hasAction(item));
//           log("role:", role);
//           log("personalDiscount:", personalDiscount);
//           log("autoTierPercent:", autoTierPercent);
//         },
//       );
//       if (isPreorder(item) && isPrivilegedRole(role)) {
//         branchUsed = "preorder_special";
//         const specialPercent = clampPercent(
//           personalDiscount + 5,
//           MAX_AUTO_DISCOUNT,
//         );
//         const preorderPrice = getPreorderPrice(item);
//         const discountedByPercent = round(
//           listPrice - (listPrice * specialPercent) / 100,
//         );
//         displayUnitPrice = preorderPrice;
//         finalUnitPrice = Math.min(preorderPrice, discountedByPercent);
//         lineDiscountType = "preorder_special";
//         lineDiscountPercent = specialPercent;
//         promoEligible = false;
//         log("branchUsed:", branchUsed);
//         log("specialPercent:", specialPercent);
//         log("preorderPrice:", preorderPrice);
//         log("discountedByPercent:", discountedByPercent);
//       } else if (role === "club_member") {
//         if (hasSale(item)) {
//           branchUsed = "club_member + sale";
//           const saleBase = getSalePrice(item);
//           displayUnitPrice = saleBase;
//           const candidate = round(
//             saleBase - (saleBase * clubExtraDiscount) / 100,
//           );
//           const minAllowed = round(saleBase * 0.6);
//           finalUnitPrice = Math.max(candidate, minAllowed);
//           lineDiscountType = "sale_plus_club";
//           lineDiscountPercent = Math.min(clubExtraDiscount, MAX_AUTO_DISCOUNT);
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//           log("saleBase:", saleBase);
//           log("candidate:", candidate);
//           log("minAllowed:", minAllowed);
//         } else if (hasAction(item)) {
//           branchUsed = "club_member + action";
//           displayUnitPrice = getActionPrice(item);
//           const fullPercent = clampPercent(
//             clampPercent(item?.actionDiscountPercent) + clubExtraDiscount,
//             MAX_AUTO_DISCOUNT,
//           );
//           finalUnitPrice = Math.max(
//             round(listPrice - (listPrice * fullPercent) / 100),
//             round(listPrice * 0.6),
//           );
//           lineDiscountType = "action_plus_club";
//           lineDiscountPercent = fullPercent;
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//           log("displayUnitPrice:", displayUnitPrice);
//           log("fullPercent:", fullPercent);
//         } else {
//           branchUsed = "club_member + tier";
//           const fullPercent = clampPercent(
//             autoTierPercent + clubExtraDiscount,
//             MAX_AUTO_DISCOUNT,
//           );
//           displayUnitPrice = listPrice;
//           finalUnitPrice = Math.max(
//             round(listPrice - (listPrice * fullPercent) / 100),
//             round(listPrice * 0.6),
//           );
//           lineDiscountType = "cart_plus_club";
//           lineDiscountPercent = fullPercent;
//           log("branchUsed:", branchUsed);
//           log("fullPercent:", fullPercent);
//         }
//       } else if (isPrivilegedRole(role)) {
//         if (hasSale(item)) {
//           branchUsed = "privileged + sale";
//           displayUnitPrice = getSalePrice(item);
//           finalUnitPrice = displayUnitPrice;
//           lineDiscountType = "sale";
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//           warn(
//             "⚠️ item has sale, personal/cart discount not applied to this item",
//           );
//         } else if (hasAction(item)) {
//           branchUsed = "privileged + action";
//           displayUnitPrice = getActionPrice(item);
//           finalUnitPrice = displayUnitPrice;
//           lineDiscountType = "action";
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//           warn(
//             "⚠️ item has action, personal/cart discount not applied to this item",
//           );
//         } else {
//           branchUsed = "privileged + best(personal vs tier)";
//           const bestPercent = Math.max(personalDiscount, autoTierPercent);
//           const effectivePercent = clampPercent(bestPercent, MAX_AUTO_DISCOUNT);
//           displayUnitPrice = listPrice;
//           finalUnitPrice = round(
//             listPrice - (listPrice * effectivePercent) / 100,
//           );
//           lineDiscountType =
//             effectivePercent === personalDiscount &&
//             personalDiscount > autoTierPercent
//               ? "personal"
//               : "cartdiscount";
//           lineDiscountPercent = effectivePercent;
//           log("branchUsed:", branchUsed);
//           log("bestPercent:", bestPercent);
//           log("effectivePercent:", effectivePercent);
//           log("lineDiscountType:", lineDiscountType);
//         }
//       } else {
//         if (hasSale(item)) {
//           branchUsed = "regular + sale";
//           displayUnitPrice = getSalePrice(item);
//           finalUnitPrice = displayUnitPrice;
//           lineDiscountType = "sale";
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//         } else if (hasAction(item)) {
//           branchUsed = "regular + action";
//           displayUnitPrice = getActionPrice(item);
//           finalUnitPrice = displayUnitPrice;
//           lineDiscountType = "action";
//           promoEligible = false;
//           log("branchUsed:", branchUsed);
//         } else if (currentUser?.uid && autoTierPercent > 0) {
//           branchUsed = "regular + tier";
//           const effectivePercent = clampPercent(
//             autoTierPercent,
//             MAX_AUTO_DISCOUNT,
//           );
//           displayUnitPrice = listPrice;
//           finalUnitPrice = round(
//             listPrice - (listPrice * effectivePercent) / 100,
//           );
//           lineDiscountType = "cartdiscount";
//           lineDiscountPercent = effectivePercent;
//           log("branchUsed:", branchUsed);
//           log("effectivePercent:", effectivePercent);
//         } else {
//           branchUsed = "regular without discount";
//           log("branchUsed:", branchUsed);
//         }
//       }
//       displaySubtotal += displayUnitPrice * qty;
//       calculatedFinal += finalUnitPrice * qty;
//       const resultLine = {
//         ...item,
//         quantity: qty,
//         listUnitPrice: listPrice,
//         displayUnitPrice,
//         finalUnitPrice,
//         displayLineTotal: displayUnitPrice * qty,
//         finalLineTotal: finalUnitPrice * qty,
//         discountType: lineDiscountType,
//         discountPercent: lineDiscountPercent,
//         promoEligible,
//         branchUsed,
//       };
//       group(
//         `✅ ITEM RESULT: ${item?.bookName || item?.title || item?.id || "item"}`,
//         () => {
//           log("displayUnitPrice:", displayUnitPrice);
//           log("finalUnitPrice:", finalUnitPrice);
//           log("displayLineTotal:", displayUnitPrice * qty);
//           log("finalLineTotal:", finalUnitPrice * qty);
//           log("lineDiscountType:", lineDiscountType);
//           log("lineDiscountPercent:", lineDiscountPercent);
//           log("promoEligible:", promoEligible);
//           log("branchUsed:", branchUsed);
//         },
//       );
//       nextLines.push(resultLine);
//     });
//     setPriceListSubtotal(round(subtotalByPriceList));
//     setTotalPrice(round(displaySubtotal));
//     setBaseFinalValue(round(calculatedFinal));
//     setPricingLines(nextLines);
//     let nextVisibleDiscount = 0;
//     let nextAppliedDiscountType = "none";
//     if (role === "club_member") {
//       nextVisibleDiscount = clampPercent(
//         autoTierPercent + clubExtraDiscount,
//         MAX_AUTO_DISCOUNT,
//       );
//       nextAppliedDiscountType = "club_member";
//       group("🎯 visible discount result: club_member", () => {
//         log("autoTierPercent:", autoTierPercent);
//         log("clubExtraDiscount:", clubExtraDiscount);
//         log("visibleDiscount:", nextVisibleDiscount);
//       });
//     } else if (isPrivilegedRole(role)) {
//       const bestPercent = Math.max(personalDiscount, autoTierPercent);
//       nextVisibleDiscount = clampPercent(bestPercent, MAX_AUTO_DISCOUNT);
//       nextAppliedDiscountType =
//         nextVisibleDiscount === personalDiscount &&
//         personalDiscount > autoTierPercent
//           ? "personal"
//           : "cartdiscount";
//       group("🎯 visible discount result: privileged", () => {
//         log("personalDiscount:", personalDiscount);
//         log("autoTierPercent:", autoTierPercent);
//         log("bestPercent:", bestPercent);
//         log("visibleDiscount:", nextVisibleDiscount);
//         log("appliedDiscountType:", nextAppliedDiscountType);
//       });
//     } else {
//       nextVisibleDiscount = clampPercent(autoTierPercent, MAX_AUTO_DISCOUNT);
//       nextAppliedDiscountType =
//         nextVisibleDiscount > 0 ? "cartdiscount" : "none";
//       group("🎯 visible discount result: regular", () => {
//         log("autoTierPercent:", autoTierPercent);
//         log("visibleDiscount:", nextVisibleDiscount);
//         log("appliedDiscountType:", nextAppliedDiscountType);
//       });
//     }
//     setVisibleDiscount(nextVisibleDiscount);
//     setAppliedDiscountType(nextAppliedDiscountType);
//     group("🧾 FINAL SUMMARY BEFORE PROMO/ELEFANT", () => {
//       log("totalPrice(displaySubtotal):", round(displaySubtotal));
//       log("priceListSubtotal:", round(subtotalByPriceList));
//       log("baseFinalValue:", round(calculatedFinal));
//       log("visibleDiscount:", nextVisibleDiscount);
//       log("appliedDiscountType:", nextAppliedDiscountType);
//       log("pricingLines:", nextLines);
//     });
//   }, [
//     cartProducts,
//     discountRules,
//     currentUser,
//     role,
//     personalDiscount,
//     clubExtraDiscount,
//   ]);
//   const newFinValue = useMemo(() => {
//     const raw = baseFinalValue - promoDiscountValue - elefantApplied;
//     const result = Math.max(round(raw), 0);
//     group("💰 newFinValue useMemo", () => {
//       log("baseFinalValue:", baseFinalValue);
//       log("promoDiscountValue:", promoDiscountValue);
//       log("elefantApplied:", elefantApplied);
//       log("raw:", raw);
//       log("result:", result);
//     });
//     return result;
//   }, [baseFinalValue, promoDiscountValue, elefantApplied]);
//   const applyPromoCode = useCallback(
//     async (promoData) => {
//       group("🎟️ applyPromoCode()", () => {
//         log("promoData:", promoData);
//         log("promoCode:", promoCode);
//         log("pricingLines:", pricingLines);
//       });
//       if (!promoData || !promoCode) {
//         warn("promo skipped: no promoData or promoCode");
//         return false;
//       }
//       if (!pricingLines.length) {
//         warn("promo skipped: no pricingLines");
//         return false;
//       }
//       const appliesTo = promoData.appliesTo || {};
//       const appliesToProducts = appliesTo.products || [];
//       const appliesToAuthors = appliesTo.authors || [];
//       const appliesToSeries = appliesTo.series || [];
//       const isUniversal =
//         appliesToProducts.length === 0 &&
//         appliesToAuthors.length === 0 &&
//         appliesToSeries.length === 0;
//       let eligibleTotal = 0;
//       pricingLines.forEach((item) => {
//         if (!item.promoEligible) {
//           warn("promo skip item: promoEligible=false", item);
//           return;
//         }
//         let match = false;
//         if (isUniversal) {
//           match = true;
//         } else {
//           const matchProduct = appliesToProducts.includes(item.id);
//           const itemAuthors = Array.isArray(item.textAutor)
//             ? item.textAutor.map(normalizeAuthorKey)
//             : typeof item.textAutor === "string"
//               ? [normalizeAuthorKey(item.textAutor)]
//               : [];
//           const promoAuthors = appliesToAuthors.map(normalizeAuthorKey);
//           const matchAuthor = itemAuthors.some((author) =>
//             promoAuthors.includes(author),
//           );
//           const itemSeries = Array.isArray(item.seria)
//             ? item.seria
//             : typeof item.seria === "string"
//               ? [item.seria]
//               : [];
//           const matchSeries = itemSeries.some((series) =>
//             appliesToSeries.includes(series),
//           );
//           match = matchProduct || matchAuthor || matchSeries;
//           log("promo item match:", {
//             id: item.id,
//             title: item.bookName || item.title,
//             matchProduct,
//             itemAuthors,
//             promoAuthors,
//             matchAuthor,
//             itemSeries,
//             appliesToSeries,
//             matchSeries,
//             finalMatch: match,
//           });
//         }
//         if (match) {
//           eligibleTotal += item.finalLineTotal;
//         }
//       });
//       log("promo eligibleTotal:", eligibleTotal);
//       if (eligibleTotal <= 0) {
//         warn("promo skipped: eligibleTotal <= 0");
//         return false;
//       }
//       const promoDiscount = round(
//         (eligibleTotal * clampPercent(promoData.discount)) / 100,
//       );
//       log("promoDiscount:", promoDiscount);
//       setPromoDiscountValue(promoDiscount);
//       if (promoData.isSingleUse) {
//         warn("promo is single use, deleting:", promoData.id);
//         await deleteDoc(doc(db, "promo", promoData.id));
//       }
//       return true;
//     },
//     [promoCode, pricingLines],
//   );
//   const applyElefant = async (requestedAmount, updateUserElefant) => {
//     group("🐘 applyElefant()", () => {
//       log("requestedAmount:", requestedAmount);
//       log("currentUser:", currentUser);
//       log("baseFinalValue:", baseFinalValue);
//       log("promoDiscountValue:", promoDiscountValue);
//       log("elefantApplied:", elefantApplied);
//     });
//     const available = toNumber(currentUser?.elefant);
//     const currentPayable = Math.max(
//       baseFinalValue - promoDiscountValue - elefantApplied,
//       0,
//     );
//     log("available elefant:", available);
//     log("currentPayable:", currentPayable);
//     if (!available || currentPayable <= 0) {
//       warn("elefant skipped: no available or currentPayable <= 0");
//       return false;
//     }
//     const wanted =
//       requestedAmount === undefined ||
//       requestedAmount === null ||
//       requestedAmount === ""
//         ? available
//         : toNumber(requestedAmount);
//     const toUse = Math.min(wanted, available, currentPayable);
//     log("wanted:", wanted);
//     log("toUse:", toUse);
//     if (toUse <= 0) {
//       warn("elefant skipped: toUse <= 0");
//       return false;
//     }
//     await updateUserElefant(currentUser.uid, toUse);
//     setElefantApplied((prev) => {
//       const next = prev + toUse;
//       log("elefantApplied prev:", prev);
//       log("elefantApplied next:", next);
//       return next;
//     });
//     return toUse;
//   };
//   useEffect(() => {
//     group("📦 STATE SNAPSHOT", () => {
//       log("totalPrice:", totalPrice);
//       log("priceListSubtotal:", priceListSubtotal);
//       log("baseFinalValue:", baseFinalValue);
//       log("promoDiscountValue:", promoDiscountValue);
//       log("elefantApplied:", elefantApplied);
//       log("visibleDiscount:", visibleDiscount);
//       log("appliedDiscountType:", appliedDiscountType);
//       log("pricingLines:", pricingLines);
//       log("promoCode:", promoCode);
//     });
//   }, [
//     totalPrice,
//     priceListSubtotal,
//     baseFinalValue,
//     promoDiscountValue,
//     elefantApplied,
//     visibleDiscount,
//     appliedDiscountType,
//     pricingLines,
//     promoCode,
//   ]);
//   return {
//     totalPrice,
//     priceListSubtotal,
//     newFinValue,
//     visibleDiscount,
//     appliedDiscountType,
//     pricingLines,
//     promoCode,
//     setPromoCode,
//     applyPromoCode,
//     applyElefant,
//     promoDiscountValue,
//     elefantApplied,
//   };
// };
import { useState, useEffect, useCallback, useMemo } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
const ROLES = {
  CLUB: 'Член "Клубу Майстрів"',
  LIBRARIAN: "Бібліотекар",
  BUSINESS: "Бізнес-партнер",
  MASTER: "Майстер",
};
const MAX_AUTO_DISCOUNT = 40;
const DEBUG_DISCOUNTS = true;
const log = (...args) => {
  if (DEBUG_DISCOUNTS) console.log(...args);
};
const warn = (...args) => {
  if (DEBUG_DISCOUNTS) console.warn(...args);
};
const errorLog = (...args) => {
  if (DEBUG_DISCOUNTS) console.error(...args);
};
const group = (title, callback) => {
  if (!DEBUG_DISCOUNTS) {
    callback();
    return;
  }
  if (console.groupCollapsed) {
    console.groupCollapsed(title);
    try {
      callback();
    } finally {
      console.groupEnd();
    }
  } else {
    callback();
  }
};
const hasValue = (value) =>
  value !== undefined && value !== null && String(value).trim() !== "";
const toNumber = (value) => Number(value) || 0;
const round = (value) => Math.round(Number(value) || 0);
const money = (value) => Number((Number(value) || 0).toFixed(2));
const clampPercent = (value, max = 100) =>
  Math.max(0, Math.min(toNumber(value), max));
const normalizeText = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
const resolveRole = (user) => {
  const rawRole =
    user?.category ??
    user?.role ??
    user?.userRole ??
    user?.roleName ??
    user?.accountType ??
    user?.customerType ??
    "";
  const normalizedRole = normalizeText(rawRole);
  let resolvedRole = user?.uid ? "user" : "guest";
  if (normalizedRole === normalizeText(ROLES.BUSINESS)) {
    resolvedRole = "business_partner";
  } else if (normalizedRole === normalizeText(ROLES.LIBRARIAN)) {
    resolvedRole = "librarian";
  } else if (normalizedRole === normalizeText(ROLES.CLUB)) {
    resolvedRole = "club_member";
  } else if (normalizedRole === normalizeText(ROLES.MASTER)) {
    resolvedRole = "master";
  }
  group("🧩 resolveRole()", () => {
    log("rawRole:", rawRole);
    log("normalizedRole:", normalizedRole);
    log("resolvedRole:", resolvedRole);
    log("user?.category:", user?.category);
    log("user?.role:", user?.role);
    log("user?.userRole:", user?.userRole);
    log("user?.accountType:", user?.accountType);
    log("user?.customerType:", user?.customerType);
  });
  return resolvedRole;
};
const isPrivilegedRole = (role) =>
  role === "business_partner" || role === "librarian";
const isTelegramSigned = (user) => {
  const raw =
    user?.signed ??
    user?.telegramSubscribed ??
    user?.isTelegramSubscribed ??
    false;
  const result = raw === true || raw === "true" || raw === 1 || raw === "1";
  group("📨 isTelegramSigned()", () => {
    log("raw:", raw);
    log("result:", result);
  });
  return result;
};
const isPreorder = (item) =>
  Boolean(
    item?.isPreorder ||
    item?.preorder ||
    item?.categorySlug === "predprodazh" ||
    item?.section === "predprodazh" ||
    item?.group === "predprodazh",
  );
const hasAction = (item) => clampPercent(item?.actionDiscountPercent) > 0;
const hasSale = (item) =>
  (hasValue(item?.priceSale) && !isPreorder(item)) ||
  clampPercent(item?.saleDiscountPercent) > 0;
const getListPrice = (item) => round(item?.price);
const getActionPrice = (item) => {
  const price = getListPrice(item);
  const percent = clampPercent(item?.actionDiscountPercent);
  const result = !percent ? price : round(price - (price * percent) / 100);
  group(
    `🏷️ getActionPrice: ${item?.bookName || item?.title || item?.id || "item"}`,
    () => {
      log("price:", price);
      log("actionDiscountPercent raw:", item?.actionDiscountPercent);
      log("actionDiscountPercent normalized:", percent);
      log("result:", result);
    },
  );
  return result;
};
const getSalePrice = (item) => {
  let result = getListPrice(item);
  if (hasValue(item?.priceSale) && !isPreorder(item)) {
    result = round(item.priceSale);
  } else {
    const price = getListPrice(item);
    const percent = clampPercent(item?.saleDiscountPercent);
    if (percent > 0) {
      result = round(price - (price * percent) / 100);
    }
  }
  group(
    `💸 getSalePrice: ${item?.bookName || item?.title || item?.id || "item"}`,
    () => {
      log("price:", getListPrice(item));
      log("priceSale raw:", item?.priceSale);
      log("saleDiscountPercent raw:", item?.saleDiscountPercent);
      log("result:", result);
    },
  );
  return result;
};
const getPreorderPrice = (item) => {
  let result = getListPrice(item);
  if (hasValue(item?.preorderPrice)) {
    result = round(item.preorderPrice);
  } else if (hasValue(item?.priceSale)) {
    result = round(item.priceSale);
  }
  group(
    `📦 getPreorderPrice: ${item?.bookName || item?.title || item?.id || "item"}`,
    () => {
      log("preorderPrice raw:", item?.preorderPrice);
      log("priceSale raw:", item?.priceSale);
      log("result:", result);
    },
  );
  return result;
};
const isRuleActiveNow = (rule) => {
  if (rule?.active === false) {
    warn("rule inactive because active=false", rule);
    return false;
  }
  const now = new Date();
  const start = hasValue(rule?.startDate) ? new Date(rule.startDate) : null;
  const end = hasValue(rule?.endDate) ? new Date(rule.endDate) : null;
  if (start && Number.isNaN(start.getTime())) {
    warn("invalid startDate in rule", rule);
    return false;
  }
  if (end && Number.isNaN(end.getTime())) {
    warn("invalid endDate in rule", rule);
    return false;
  }
  if (start && now < start) return false;
  if (end && now > end) return false;
  return true;
};
const getTierPercent = (rules, priceListSubtotal) => {
  group("📚 getTierPercent()", () => {
    log("priceListSubtotal:", priceListSubtotal);
    log("rules:", rules);
  });
  const matched = [...rules]
    .filter((rule) => {
      const amount = toNumber(rule?.amount || 0);
      const active = isRuleActiveNow(rule);
      const subtotalOk = priceListSubtotal >= amount;
      log("rule check:", {
        id: rule?.id,
        amountRaw: rule?.amount,
        amount,
        percent: rule?.percent,
        active,
        subtotalOk,
        priceListSubtotal,
      });
      return active && subtotalOk;
    })
    .sort((a, b) => toNumber(b?.amount || 0) - toNumber(a?.amount || 0));
  const result = matched.length
    ? clampPercent(matched[0]?.percent, MAX_AUTO_DISCOUNT)
    : 0;
  group("📚 getTierPercent result", () => {
    log("matched:", matched);
    log("result:", result);
  });
  return result;
};
const normalizeAuthorKey = (value) =>
  String(value || "")
    .trim()
    .split(" ")[0]
    .toLowerCase();
const calcDiscountedLineTotal = (unitPrice, qty, percent) => {
  const lineBaseTotal = toNumber(unitPrice) * toNumber(qty);
  return round(lineBaseTotal - (lineBaseTotal * toNumber(percent)) / 100);
};
export const useCartCalculations = ({
  cartProducts = [],
  discountInHok = 0,
  currentUser,
}) => {
  const [discountRules, setDiscountRules] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [priceListSubtotal, setPriceListSubtotal] = useState(0);
  const [baseFinalValue, setBaseFinalValue] = useState(0);
  const [promoDiscountValue, setPromoDiscountValue] = useState(0);
  const [elefantApplied, setElefantApplied] = useState(0);
  const [visibleDiscount, setVisibleDiscount] = useState(0);
  const [appliedDiscountType, setAppliedDiscountType] = useState("none");
  const [pricingLines, setPricingLines] = useState([]);
  const [promoCode, setPromoCode] = useState("");
  const role = resolveRole(currentUser);
  const personalDiscountRaw =
    currentUser?.discount ??
    currentUser?.personalDiscount ??
    currentUser?.userDiscount ??
    discountInHok ??
    0;
  const personalDiscount = clampPercent(personalDiscountRaw, MAX_AUTO_DISCOUNT);
  const clubExtraDiscount = isTelegramSigned(currentUser) ? 5 : 0;
  useEffect(() => {
    const loadRules = async () => {
      try {
        const snap = await getDocs(collection(db, "cartdiscount"));
        const rules = snap.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));
        group("🗂️ cartdiscount rules loaded", () => {
          log("rules:", rules);
        });
        setDiscountRules(rules);
      } catch (err) {
        errorLog("❌ error loading cartdiscount", err);
      }
    };
    loadRules();
  }, []);
  useEffect(() => {
    group("🚀 useCartCalculations INIT", () => {
      log("currentUser:", currentUser);
      log("currentUser keys:", Object.keys(currentUser || {}));
      log("currentUser.category:", currentUser?.category);
      log("resolved role:", role);
      log("currentUser.discount:", currentUser?.discount);
      log("discountInHok prop:", discountInHok);
      log("personalDiscountRaw:", personalDiscountRaw);
      log("personalDiscount clamped:", personalDiscount);
      log("currentUser.signed:", currentUser?.signed);
      log("clubExtraDiscount:", clubExtraDiscount);
      log("currentUser.elefant:", currentUser?.elefant);
    });
  }, [
    currentUser,
    role,
    discountInHok,
    personalDiscountRaw,
    personalDiscount,
    clubExtraDiscount,
  ]);
  useEffect(() => {
    group("🧮 MAIN CALCULATION START", () => {
      log("role:", role);
      log("personalDiscount:", personalDiscount);
      log("discountRules:", discountRules);
      log("cartProducts:", cartProducts);
    });
    const subtotalByPriceList = (cartProducts || []).reduce((acc, item) => {
      const listPrice = getListPrice(item);
      const qty = toNumber(item.quantity || 1);
      const line = listPrice * qty;
      log("subtotal item:", {
        id: item?.id,
        title: item?.bookName || item?.title,
        listPrice,
        qty,
        line,
      });
      return acc + line;
    }, 0);
    const autoTierPercent = currentUser?.uid
      ? getTierPercent(discountRules, subtotalByPriceList)
      : 0;
    group("📊 subtotal + tier", () => {
      log("subtotalByPriceList:", subtotalByPriceList);
      log("currentUser.uid:", currentUser?.uid);
      log("autoTierPercent:", autoTierPercent);
      log("personalDiscount:", personalDiscount);
      log("isPrivilegedRole(role):", isPrivilegedRole(role));
    });
    let displaySubtotal = 0;
    let calculatedFinal = 0;
    const nextLines = [];
    (cartProducts || []).forEach((item, index) => {
      const qty = toNumber(item.quantity || 1);
      const listPrice = getListPrice(item);
      const listLineTotal = listPrice * qty;
      let displayUnitPrice = listPrice;
      let finalUnitPrice = listPrice;
      let displayLineTotal = listLineTotal;
      let finalLineTotal = listLineTotal;
      let lineDiscountType = "none";
      let lineDiscountPercent = 0;
      let promoEligible = true;
      let branchUsed = "none";
      group(
        `📘 ITEM #${index + 1}: ${item?.bookName || item?.title || item?.id || "item"}`,
        () => {
          log("raw item:", item);
          log("qty:", qty);
          log("listPrice:", listPrice);
          log("listLineTotal:", listLineTotal);
          log("isPreorder:", isPreorder(item));
          log("hasSale:", hasSale(item));
          log("hasAction:", hasAction(item));
          log("role:", role);
          log("personalDiscount:", personalDiscount);
          log("autoTierPercent:", autoTierPercent);
        },
      );
      if (isPreorder(item) && isPrivilegedRole(role)) {
        branchUsed = "preorder_special";
        const specialPercent = clampPercent(
          personalDiscount + 5,
          MAX_AUTO_DISCOUNT,
        );
        const preorderPrice = getPreorderPrice(item);
        const preorderLineTotal = preorderPrice * qty;
        const discountedByPercentLineTotal = calcDiscountedLineTotal(
          listPrice,
          qty,
          specialPercent,
        );
        displayLineTotal = preorderLineTotal;
        finalLineTotal = Math.min(
          preorderLineTotal,
          discountedByPercentLineTotal,
        );
        displayUnitPrice = money(displayLineTotal / qty);
        finalUnitPrice = money(finalLineTotal / qty);
        lineDiscountType = "preorder_special";
        lineDiscountPercent = specialPercent;
        promoEligible = false;
        log("branchUsed:", branchUsed);
        log("specialPercent:", specialPercent);
        log("preorderPrice:", preorderPrice);
        log("preorderLineTotal:", preorderLineTotal);
        log("discountedByPercentLineTotal:", discountedByPercentLineTotal);
        log("finalLineTotal:", finalLineTotal);
      } else if (role === "club_member") {
        if (hasSale(item)) {
          branchUsed = "club_member + sale";
          const saleBase = getSalePrice(item);
          const saleLineTotal = saleBase * qty;
          const candidateLineTotal = round(
            saleLineTotal - (saleLineTotal * clubExtraDiscount) / 100,
          );
          const minAllowedLineTotal = round(saleLineTotal * 0.6);
          displayLineTotal = saleLineTotal;
          finalLineTotal = Math.max(candidateLineTotal, minAllowedLineTotal);
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "sale_plus_club";
          lineDiscountPercent = Math.min(clubExtraDiscount, MAX_AUTO_DISCOUNT);
          promoEligible = false;
          log("branchUsed:", branchUsed);
          log("saleBase:", saleBase);
          log("saleLineTotal:", saleLineTotal);
          log("candidateLineTotal:", candidateLineTotal);
          log("minAllowedLineTotal:", minAllowedLineTotal);
          log("finalLineTotal:", finalLineTotal);
        } else if (hasAction(item)) {
          branchUsed = "club_member + action";
          const actionUnitPrice = getActionPrice(item);
          const actionLineTotal = actionUnitPrice * qty;
          const fullPercent = clampPercent(
            clampPercent(item?.actionDiscountPercent) + clubExtraDiscount,
            MAX_AUTO_DISCOUNT,
          );
          const discountedLineTotal = calcDiscountedLineTotal(
            listPrice,
            qty,
            fullPercent,
          );
          const minAllowedLineTotal = round(listLineTotal * 0.6);
          displayLineTotal = actionLineTotal;
          finalLineTotal = Math.max(discountedLineTotal, minAllowedLineTotal);
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "action_plus_club";
          lineDiscountPercent = fullPercent;
          promoEligible = false;
          log("branchUsed:", branchUsed);
          log("actionUnitPrice:", actionUnitPrice);
          log("actionLineTotal:", actionLineTotal);
          log("fullPercent:", fullPercent);
          log("discountedLineTotal:", discountedLineTotal);
          log("minAllowedLineTotal:", minAllowedLineTotal);
          log("finalLineTotal:", finalLineTotal);
        } else {
          branchUsed = "club_member + tier";
          const fullPercent = clampPercent(
            autoTierPercent + clubExtraDiscount,
            MAX_AUTO_DISCOUNT,
          );
          displayLineTotal = listLineTotal;
          finalLineTotal = Math.max(
            calcDiscountedLineTotal(listPrice, qty, fullPercent),
            round(listLineTotal * 0.6),
          );
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "cart_plus_club";
          lineDiscountPercent = fullPercent;
          log("branchUsed:", branchUsed);
          log("fullPercent:", fullPercent);
          log("finalLineTotal:", finalLineTotal);
        }
      } else if (isPrivilegedRole(role)) {
        if (hasSale(item)) {
          branchUsed = "privileged + sale";
          const saleUnitPrice = getSalePrice(item);
          const saleLineTotal = saleUnitPrice * qty;
          displayLineTotal = saleLineTotal;
          finalLineTotal = saleLineTotal;
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "sale";
          promoEligible = false;
          log("branchUsed:", branchUsed);
          warn(
            "⚠️ item has sale, personal/cart discount not applied to this item",
          );
        } else if (hasAction(item)) {
          branchUsed = "privileged + action";
          const actionUnitPrice = getActionPrice(item);
          const actionLineTotal = actionUnitPrice * qty;
          displayLineTotal = actionLineTotal;
          finalLineTotal = actionLineTotal;
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "action";
          promoEligible = false;
          log("branchUsed:", branchUsed);
          warn(
            "⚠️ item has action, personal/cart discount not applied to this item",
          );
        } else {
          branchUsed = "privileged + best(personal vs tier)";
          const bestPercent = Math.max(personalDiscount, autoTierPercent);
          const effectivePercent = clampPercent(bestPercent, MAX_AUTO_DISCOUNT);
          displayLineTotal = listLineTotal;
          finalLineTotal = calcDiscountedLineTotal(
            listPrice,
            qty,
            effectivePercent,
          );
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType =
            effectivePercent === personalDiscount &&
            personalDiscount > autoTierPercent
              ? "personal"
              : "cartdiscount";
          lineDiscountPercent = effectivePercent;
          log("branchUsed:", branchUsed);
          log("bestPercent:", bestPercent);
          log("effectivePercent:", effectivePercent);
          log("displayLineTotal:", displayLineTotal);
          log("finalLineTotal:", finalLineTotal);
          log("lineDiscountType:", lineDiscountType);
        }
      } else {
        if (hasSale(item)) {
          branchUsed = "regular + sale";
          const saleUnitPrice = getSalePrice(item);
          const saleLineTotal = saleUnitPrice * qty;
          displayLineTotal = saleLineTotal;
          finalLineTotal = saleLineTotal;
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "sale";
          promoEligible = false;
          log("branchUsed:", branchUsed);
        } else if (hasAction(item)) {
          branchUsed = "regular + action";
          const actionUnitPrice = getActionPrice(item);
          const actionLineTotal = actionUnitPrice * qty;
          displayLineTotal = actionLineTotal;
          finalLineTotal = actionLineTotal;
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "action";
          promoEligible = false;
          log("branchUsed:", branchUsed);
        } else if (currentUser?.uid && autoTierPercent > 0) {
          branchUsed = "regular + tier";
          const effectivePercent = clampPercent(
            autoTierPercent,
            MAX_AUTO_DISCOUNT,
          );
          displayLineTotal = listLineTotal;
          finalLineTotal = calcDiscountedLineTotal(
            listPrice,
            qty,
            effectivePercent,
          );
          displayUnitPrice = money(displayLineTotal / qty);
          finalUnitPrice = money(finalLineTotal / qty);
          lineDiscountType = "cartdiscount";
          lineDiscountPercent = effectivePercent;
          log("branchUsed:", branchUsed);
          log("effectivePercent:", effectivePercent);
          log("displayLineTotal:", displayLineTotal);
          log("finalLineTotal:", finalLineTotal);
        } else {
          branchUsed = "regular without discount";
          log("branchUsed:", branchUsed);
        }
      }
      displaySubtotal += displayLineTotal;
      calculatedFinal += finalLineTotal;
      const resultLine = {
        ...item,
        quantity: qty,
        listUnitPrice: listPrice,
        displayUnitPrice,
        finalUnitPrice,
        displayLineTotal: round(displayLineTotal),
        finalLineTotal: round(finalLineTotal),
        discountType: lineDiscountType,
        discountPercent: lineDiscountPercent,
        promoEligible,
        branchUsed,
      };
      group(
        `✅ ITEM RESULT: ${item?.bookName || item?.title || item?.id || "item"}`,
        () => {
          log("displayUnitPrice:", displayUnitPrice);
          log("finalUnitPrice:", finalUnitPrice);
          log("displayLineTotal:", resultLine.displayLineTotal);
          log("finalLineTotal:", resultLine.finalLineTotal);
          log("lineDiscountType:", lineDiscountType);
          log("lineDiscountPercent:", lineDiscountPercent);
          log("promoEligible:", promoEligible);
          log("branchUsed:", branchUsed);
        },
      );
      nextLines.push(resultLine);
    });
    setPriceListSubtotal(round(subtotalByPriceList));
    setTotalPrice(round(displaySubtotal));
    setBaseFinalValue(round(calculatedFinal));
    setPricingLines(nextLines);
    let nextVisibleDiscount = 0;
    let nextAppliedDiscountType = "none";
    if (role === "club_member") {
      nextVisibleDiscount = clampPercent(
        autoTierPercent + clubExtraDiscount,
        MAX_AUTO_DISCOUNT,
      );
      nextAppliedDiscountType = "club_member";
    } else if (isPrivilegedRole(role)) {
      const bestPercent = Math.max(personalDiscount, autoTierPercent);
      nextVisibleDiscount = clampPercent(bestPercent, MAX_AUTO_DISCOUNT);
      nextAppliedDiscountType =
        nextVisibleDiscount === personalDiscount &&
        personalDiscount > autoTierPercent
          ? "personal"
          : "cartdiscount";
    } else {
      nextVisibleDiscount = clampPercent(autoTierPercent, MAX_AUTO_DISCOUNT);
      nextAppliedDiscountType =
        nextVisibleDiscount > 0 ? "cartdiscount" : "none";
    }
    setVisibleDiscount(nextVisibleDiscount);
    setAppliedDiscountType(nextAppliedDiscountType);
    group("🧾 FINAL SUMMARY BEFORE PROMO/ELEFANT", () => {
      log("totalPrice(displaySubtotal):", round(displaySubtotal));
      log("priceListSubtotal:", round(subtotalByPriceList));
      log("baseFinalValue:", round(calculatedFinal));
      log("visibleDiscount:", nextVisibleDiscount);
      log("appliedDiscountType:", nextAppliedDiscountType);
      log("pricingLines:", nextLines);
    });
  }, [
    cartProducts,
    discountRules,
    currentUser,
    role,
    personalDiscount,
    clubExtraDiscount,
  ]);
  const newFinValue = useMemo(() => {
    const raw = baseFinalValue - promoDiscountValue - elefantApplied;
    const result = Math.max(round(raw), 0);
    group("💰 newFinValue useMemo", () => {
      log("baseFinalValue:", baseFinalValue);
      log("promoDiscountValue:", promoDiscountValue);
      log("elefantApplied:", elefantApplied);
      log("raw:", raw);
      log("result:", result);
    });
    return result;
  }, [baseFinalValue, promoDiscountValue, elefantApplied]);
  const applyPromoCode = useCallback(
    async (promoData) => {
      group("🎟️ applyPromoCode()", () => {
        log("promoData:", promoData);
        log("promoCode:", promoCode);
        log("pricingLines:", pricingLines);
      });
      if (!promoData || !promoCode) {
        warn("promo skipped: no promoData or promoCode");
        return false;
      }
      if (!pricingLines.length) {
        warn("promo skipped: no pricingLines");
        return false;
      }
      const appliesTo = promoData.appliesTo || {};
      const appliesToProducts = appliesTo.products || [];
      const appliesToAuthors = appliesTo.authors || [];
      const appliesToSeries = appliesTo.series || [];
      const isUniversal =
        appliesToProducts.length === 0 &&
        appliesToAuthors.length === 0 &&
        appliesToSeries.length === 0;
      let eligibleTotal = 0;
      pricingLines.forEach((item) => {
        if (!item.promoEligible) {
          warn("promo skip item: promoEligible=false", item);
          return;
        }
        let match = false;
        if (isUniversal) {
          match = true;
        } else {
          const matchProduct = appliesToProducts.includes(item.id);
          const itemAuthors = Array.isArray(item.textAutor)
            ? item.textAutor.map(normalizeAuthorKey)
            : typeof item.textAutor === "string"
              ? [normalizeAuthorKey(item.textAutor)]
              : [];
          const promoAuthors = appliesToAuthors.map(normalizeAuthorKey);
          const matchAuthor = itemAuthors.some((author) =>
            promoAuthors.includes(author),
          );
          const itemSeries = Array.isArray(item.seria)
            ? item.seria
            : typeof item.seria === "string"
              ? [item.seria]
              : [];
          const matchSeries = itemSeries.some((series) =>
            appliesToSeries.includes(series),
          );
          match = matchProduct || matchAuthor || matchSeries;
          log("promo item match:", {
            id: item.id,
            title: item.bookName || item.title,
            matchProduct,
            itemAuthors,
            promoAuthors,
            matchAuthor,
            itemSeries,
            appliesToSeries,
            matchSeries,
            finalMatch: match,
          });
        }
        if (match) {
          eligibleTotal += item.finalLineTotal;
        }
      });
      log("promo eligibleTotal:", eligibleTotal);
      if (eligibleTotal <= 0) {
        warn("promo skipped: eligibleTotal <= 0");
        return false;
      }
      const promoDiscount = round(
        (eligibleTotal * clampPercent(promoData.discount)) / 100,
      );
      log("promoDiscount:", promoDiscount);
      setPromoDiscountValue(promoDiscount);
      if (promoData.isSingleUse) {
        warn("promo is single use, deleting:", promoData.id);
        await deleteDoc(doc(db, "promo", promoData.id));
      }
      return true;
    },
    [promoCode, pricingLines],
  );
  const applyElefant = async (requestedAmount, updateUserElefant) => {
    group("🐘 applyElefant()", () => {
      log("requestedAmount:", requestedAmount);
      log("currentUser:", currentUser);
      log("baseFinalValue:", baseFinalValue);
      log("promoDiscountValue:", promoDiscountValue);
      log("elefantApplied:", elefantApplied);
    });

    const available = toNumber(currentUser?.elefant);
    const currentPayable = Math.max(
      baseFinalValue - promoDiscountValue - elefantApplied,
      0,
    );

    log("available elefant:", available);
    log("currentPayable:", currentPayable);

    if (!available || currentPayable <= 0) {
      warn("elefant skipped: no available or currentPayable <= 0");
      return false;
    }

    if (typeof updateUserElefant !== "function") {
      warn("elefant skipped: updateUserElefant is not a function");
      return false;
    }

    const wanted =
      requestedAmount === undefined ||
      requestedAmount === null ||
      requestedAmount === ""
        ? available
        : toNumber(requestedAmount);

    const toUse = Math.min(wanted, available, currentPayable);

    log("wanted:", wanted);
    log("toUse:", toUse);

    if (toUse <= 0) {
      warn("elefant skipped: toUse <= 0");
      return false;
    }

    await updateUserElefant(currentUser.uid, toUse);

    setElefantApplied((prev) => {
      const next = prev + toUse;
      log("elefantApplied prev:", prev);
      log("elefantApplied next:", next);
      return next;
    });

    return toUse;
  };
  useEffect(() => {
    group("📦 STATE SNAPSHOT", () => {
      log("totalPrice:", totalPrice);
      log("priceListSubtotal:", priceListSubtotal);
      log("baseFinalValue:", baseFinalValue);
      log("promoDiscountValue:", promoDiscountValue);
      log("elefantApplied:", elefantApplied);
      log("visibleDiscount:", visibleDiscount);
      log("appliedDiscountType:", appliedDiscountType);
      log("pricingLines:", pricingLines);
      log("promoCode:", promoCode);
    });
  }, [
    totalPrice,
    priceListSubtotal,
    baseFinalValue,
    promoDiscountValue,
    elefantApplied,
    visibleDiscount,
    appliedDiscountType,
    pricingLines,
    promoCode,
  ]);
  return {
    totalPrice,
    priceListSubtotal,
    newFinValue,
    visibleDiscount,
    appliedDiscountType,
    pricingLines,
    promoCode,
    setPromoCode,
    applyPromoCode,
    applyElefant,
    promoDiscountValue,
    elefantApplied,
  };
};
